import { AAABarrier } from "@ciaopeople/cp-shatsu/AAA";
import { isFunction, isObject } from "@ciaopeople/cp-shatsu/TypeChecking";
import { MembershipDialogFlag } from "../ClientSdkPublicInterface.js";





export enum BarrierDisplayMode {

    OPEN_URL = "open_url",
    SHOW_DIALOG = "show_dialog"
}

export enum LoginExtent {

    REGISTER_USER = "register_user",
    REGISTER_USER_WITH_VALID_EMAIL = "valid_mail",
    REGISTER_USER_WITH_VALID_EMAIL_AND_PERSONAL_DATA = "valid_mail_and_pd",
    REGISTER_USER_WITH_VALID_EMAIL_2STEPS = "valid_mail_2steps",
    REGISTER_USER_WITH_VALID_EMAIL_AND_PERSONAL_DATA_2STEPS = "valid_mail_and_pd_2steps" 
    
}


export type TrackingAndLoginOptions = { 
    utm_medium?: string,
    utm_source?: string,
    cta_topic?: string,
    redirect_url?: string,
    topic_label?: string,
    dialog_title?: string,
    dialog_subtitle?: string,
    dialog_button?: string,
    alternative_dialog_title?: string,
    alternative_dialog_subtitle?: string,
    alternative_dialog_button?: string
};

export interface AAABarrierWithSource<Source, Barricaded> extends AAABarrier<Barricaded> {

    executeWithBarrierWithSource<A>(dom: Source, func: (barr: Barricaded) => Promise<A>): Promise<A|void>

    executeWithBarrierAndOptions<A>(func: (barr: Barricaded) => Promise<A>, options?: TrackingAndLoginOptions, 
                                    membershipFlags?: MembershipDialogFlag[],
                                    loginExtent?: LoginExtent,
                                    overrideBarrierDisplayMode?: BarrierDisplayMode
                                ): Promise<A|void>;

}

export function isAAABarrierWithSource<Source, Barricaded>(obj: any): obj is AAABarrierWithSource<Source, Barricaded> {
    return isObject(obj) && isFunction(obj.executeWithBarrierWithSource);
}

export class AAABarrierWithSourceWrappingImpl<Source, Barricaded> implements AAABarrierWithSource<Source, Barricaded> {

    constructor(private wrapped: AAABarrier<Barricaded>) {
    }

    public executeWithBarrierWithSource<A>(dom: Source, func: (barr: Barricaded) => Promise<A>): Promise<A|void> {
        return this.wrapped.executeWithBarrier(func);
    }
    public executeWithBarrier<A>(func: (barr: Barricaded) => Promise<A>): Promise<A|void> {
        return this.wrapped.executeWithBarrier(func);
    }
    public getBarricadedService(): Barricaded {
        return this.wrapped.getBarricadedService();
    }

    public executeWithBarrierAndOptions<A>(func: (barr: Barricaded) => Promise<A>, options?: TrackingAndLoginOptions, 
                    membershipFlags?: MembershipDialogFlag[],
                    loginExtent?: LoginExtent,
                    overrideBarrierDisplayMode?: BarrierDisplayMode
                ): Promise<A|void> {
                        return this.wrapped.executeWithBarrier(func);
                    }
}



